import { render, staticRenderFns } from "./ProjectTenders.vue?vue&type=template&id=5f878588&"
import script from "./ProjectTenders.vue?vue&type=script&lang=js&"
export * from "./ProjectTenders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports